export default __webpack_public_path__ + "static/media/tel.5546a0ed.png";